module.exports = __webpack_public_path__ + "static/media/serv_informados.6cab7179.svg";